import {RadioGroup as MuiRadioGroup} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";


interface RadioGroupItems<T> {
    label: string
    value: T
}

interface RadioGroupProps<T> {
    values: RadioGroupItems<T>[];
    defaultValue: T;
    onChange: (t: T) => void;
}

export function RadioGroup<T>({
                                  values,
                                  defaultValue,
                                  onChange,
                              }: RadioGroupProps<T>) {

    function handleRadioChange(e) {
        onChange(e.target.value)
    }

    return <MuiRadioGroup
        defaultValue={defaultValue}
        name="report-type-group"
        onChange={handleRadioChange}
    >
        {
            values.map(v => <FormControlLabel key={`radio-${v.value}`} value={v.value} control={<Radio/>} label={v.label}/>)
        }
    </MuiRadioGroup>
}